import { AnyAction } from 'redux';
import { ymdToMdyFormat } from '../../global/helpers/date-helpers';
import { ClergyBioActionTypes, ClergyBioAppState, ClergyBioChurchEducation, ClergyBioChurchProfessional, ClergyBioChurchMinistries, ClergyBioChurchVolunteer, ClergyBioChurchRelationship, ClergyBioChurchRerpot, ClergyBioContext, CleryBioPersonInfo, Ecclesiatics, DataState, LoadingState, InstitutionInfo } from './model/clergy-bio-app-models';


const initialState: ClergyBioAppState =
{
	context: ClergyBioContext.SUMMARY,
	personInfo: null,
	churchReport: null,
	relationship: null,
	education: null,
	ministries: null,
	volunteer: null,
	professional: null,
	ecclesiastics: null,
	institutions: null,
	loaded: {
		personInfo: DataState.EMPTY,
		churchReport: DataState.EMPTY,
		relationship: DataState.EMPTY,
		education: DataState.EMPTY,
		ministries: DataState.EMPTY,
		volunteer: DataState.EMPTY,
		professional: DataState.EMPTY,
		ecclesiastics: DataState.EMPTY,
		institutions: DataState.EMPTY,
	},
};

export const clergyBioReducer = (state = initialState, action: AnyAction): ClergyBioAppState => {
	const { type, payload } = action;

	switch (type) {

		case ClergyBioActionTypes.SET_CLERGY_BIO_PERSONAL_INFO:
			return {
				...state,
				personInfo: payload,
				loaded: { ...state.loaded, personInfo: DataState.LOADED },
			};
		case ClergyBioActionTypes.SET_CLERGY_BIO_CHURCH_REPORT:
			return {
				...state, churchReport: payload,
				loaded: { ...state.loaded, churchReport: DataState.LOADED },
			};
		case ClergyBioActionTypes.SET_CLERGY_BIO_MINISTRIES:
			return {
				...state, ministries: payload,
				loaded: { ...state.loaded, ministries: DataState.LOADED },
			};
		case ClergyBioActionTypes.SET_CLERGY_BIO_EDUCATION:
			return {
				...state, education: payload,
				loaded: { ...state.loaded, education: DataState.LOADED },
			};
		case ClergyBioActionTypes.SET_CLERGY_BIO_PROFESSIONAL:
			return {
				...state, professional: payload,
				loaded: { ...state.loaded, professional: DataState.LOADED },
			};
		case ClergyBioActionTypes.SET_CLERGY_BIO_RELATIONSHIP:
			return {
				...state, relationship: payload,
				loaded: { ...state.loaded, relationship: DataState.LOADED },
			};
		case ClergyBioActionTypes.SET_CLERGY_BIO_VOLUNTEER:
			return {
				...state, volunteer: payload,
				loaded: { ...state.loaded, volunteer: DataState.LOADED },
			};
		case ClergyBioActionTypes.SET_CLERGY_BIO_ECCLESIASTICS:
			return {
				...state, ecclesiastics: payload,
				loaded: { ...state.loaded, ecclesiastics: DataState.LOADED },
			};

		case ClergyBioActionTypes.SET_CLERGY_BIO_LOADINGSTATE:
			return {
				...state,
				loaded: { ...state.loaded, [payload?.key]: payload?.status },
			};

		case ClergyBioActionTypes.SET_CLERGY_BIO_INSTITUTIONS:
			return {
				...state, institutions: payload,
				loaded: { ...state.loaded, institutions: DataState.LOADED },
			};

		default: return state;
	}
};

export const setClergyBioPersonalInfo = (data: CleryBioPersonInfo) => {
	return {
		type: ClergyBioActionTypes.SET_CLERGY_BIO_PERSONAL_INFO,
		payload: data,
	};
};

export const setClergyBioChurchReport = (data: ClergyBioChurchRerpot) => {
	return {
		type: ClergyBioActionTypes.SET_CLERGY_BIO_CHURCH_REPORT,
		payload: data,
	};
};
export const setClergyBioRelationship = (data: ClergyBioChurchRelationship) => {
	return {
		type: ClergyBioActionTypes.SET_CLERGY_BIO_RELATIONSHIP,
		payload: data,
	};
};
export const setClergyBioEducation = (data: ClergyBioChurchEducation) => {
	return {
		type: ClergyBioActionTypes.SET_CLERGY_BIO_EDUCATION,
		payload: data,
	};
};

const slash = '/';

export function preProcessMinistry(data: ClergyBioChurchMinistries) {
	const mis = data?.miscellaneous.details?.map(a => {
		return {
			...a,
			dateBegan: !a?.dateBegan ? null : ymdToMdyFormat(a?.dateBegan, slash),
			dateEnded: !a?.dateEnded ? null : ymdToMdyFormat(a?.dateEnded, slash),
		};
	});
	const stipe = data?.stipendiary.details?.map(a => {
		const positions = a.positions?.map(p => {
			return {
				...p,
				dateBegan: !p?.dateBegan ? null : ymdToMdyFormat(p?.dateBegan, slash),
				dateEnded: !p?.dateEnded ? null : ymdToMdyFormat(p?.dateEnded, slash),
			};
		});
		return {
			...a,
			dateBegan: !a?.dateBegan ? null : ymdToMdyFormat(a?.dateBegan, slash),
			dateEnded: !a?.dateEnded ? null : ymdToMdyFormat(a?.dateEnded, slash),
			positions,
			institutionParsed: `${a?.institutionInfo?.name} ${a?.institutionInfo?.location}`,
		};
	});
	const nonStipe = data?.nonStipendiary.details?.map(a => {
		const positions = a.positions?.map(p => {
			return {
				...p,
				dateBegan: !p?.dateBegan ? null : ymdToMdyFormat(p?.dateBegan, slash),
				dateEnded: !p?.dateEnded ? null : ymdToMdyFormat(p?.dateEnded, slash),
			};
		});
		return {
			...a,
			positions,
			dateBegan: !a?.dateBegan ? null : ymdToMdyFormat(a?.dateBegan, slash),
			dateEnded: !a?.dateEnded ? null : ymdToMdyFormat(a?.dateEnded, slash),
			institutionParsed: `${a?.institutionInfo?.name} ${a?.institutionInfo?.location}`,
		};
	});

	return {
		miscellaneous: {
			...data?.miscellaneous,
			details: mis,
		},
		stipendiary: {
			...data?.stipendiary,
			details: stipe,
		},
		nonStipendiary:
		{
			...data?.nonStipendiary,
			details: nonStipe,
		},
	};
}

export const setClergyBioMinistries = (data: ClergyBioChurchMinistries) => {
	return {
		type: ClergyBioActionTypes.SET_CLERGY_BIO_MINISTRIES,
		payload: preProcessMinistry(data),
	};
};

export function preProcessVolunteer(data: ClergyBioChurchVolunteer) {

	const episcopal = data?.episcopal?.details?.map(a => {
		return {
			...a,
			dateBegan: !a?.dateBegan ? null : ymdToMdyFormat(a?.dateBegan, slash),
			dateEnded: !a?.dateEnded ? null : ymdToMdyFormat(a?.dateEnded, slash),
			institutionParsed: `${(a?.institutionInfo as InstitutionInfo).name} ${(a?.institutionInfo as InstitutionInfo).location}`?.trim(),
		};
	});

	const mis = data?.miscellaneous?.details?.map(a => {
		return {
			...a,
			dateBegan: !a?.dateBegan ? null : ymdToMdyFormat(a?.dateBegan, slash),
			dateEnded: !a?.dateEnded ? null : ymdToMdyFormat(a?.dateEnded, slash),
		};
	});

	return {
		episcopal: {
			...data?.episcopal,
			details: episcopal,
		},
		miscellaneous: {
			...data?.miscellaneous,
			details: mis,
		},
		error: data?.error,
	};
}
export const setClergyBioVolunteer = (data: ClergyBioChurchVolunteer) => {
	return {
		type: ClergyBioActionTypes.SET_CLERGY_BIO_VOLUNTEER,
		payload: preProcessVolunteer(data),
	};
};
export const setClergyBioProfessional = (data: ClergyBioChurchProfessional) => {
	return {
		type: ClergyBioActionTypes.SET_CLERGY_BIO_PROFESSIONAL,
		payload: data,
	};
};

export const setClergyBioEcclesiastics = (data: Ecclesiatics) => {
	return {
		type: ClergyBioActionTypes.SET_CLERGY_BIO_ECCLESIASTICS,
		payload: data,
	};
};

export const setLoadingState = (status: DataState, key: keyof LoadingState) => {
	return {
		type: ClergyBioActionTypes.SET_CLERGY_BIO_LOADINGSTATE,
		payload: {
			key,
			status,
		},
	};
};

export const setClergyBioInstitutions = (data: any) => {
	return {
		type: ClergyBioActionTypes.SET_CLERGY_BIO_INSTITUTIONS,
		payload: data,
	};
};